module.exports = __webpack_public_path__ + "img/stand height.3b3f69d1.png";